module.exports = __webpack_public_path__ + "static/media/blog_image.52e3b2fb.png";